module.exports = __webpack_public_path__ + "img/磁县童装.86392b3b.jpg";